import { useContext } from 'react';
import { ExposureImportJobContext } from './context';

export default function useImportExposuresJobContext() {
  return useContext(ExposureImportJobContext);
}
